@if ({ legalDocumentError: 'message.CommonServerErrorDetail' | translate,
       termsAndConditionsContentTitle: 'label.TermsAndConditions' | translate,
       privacyPolicyTitle: 'label.PrivacyPolicy' | translate }; as data) {
  <div [ngClass]="{ 'registration-page': !isModalOpened, 'registration-page--modal': isModalOpened }">
    <div [ngClass]="{ 'registration-card': !isModalOpened, 'registration-card--modal': isModalOpened }">
      @if (!isModalOpened) {
        <p-tabs class="auth-tabs" [showNavigators]="false" [value]="registrationTab" (valueChange)="onTabChange($event)">
          <p-tablist>
            <p-tab [value]="signInTab">{{ 'label.SignIn' | translate }}</p-tab>
            <p-tab [value]="registrationTab">{{ 'label.Registration' | translate }}</p-tab>
          </p-tablist>
        </p-tabs>
      }

      <div class="registration-card__body">
        <app-spinner [isLoading]="isLoading$ | async" [isFixedPosition]="false">
          @if (!isModalOpened) {
            <h1 class="registration-heading">{{ 'label.Registration' | translate }}</h1>
            <p class="registration-subheading">{{ 'label.ForJobseeker' | translate }}</p>
          }

          <form class="registration-form" [formGroup]="registrationForm" #ngForm="ngForm" (ngSubmit)="onRegister()">
            <div class="auth-field">
              <hrra-floating-field>
                <input pInputText id="registration-email" type="email" autocomplete="email" formControlName="email" />
                <label for="registration-email">{{ 'label.Email' | translate }}&nbsp;<span class="auth-field__required">*</span></label>
              </hrra-floating-field>
              @if (registrationForm.controls['email'].touched || ngForm.submitted) {
                @if (registrationForm.controls['email'].errors?.required) {
                  <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
                }
                @if (registrationForm.controls['email'].errors?.pattern) {
                  <div class="auth-field__error">{{ 'message.IncorrectFormat' | translate }}</div>
                }
                @if (registrationForm.controls['email'].errors?.server != null) {
                  <div class="auth-field__error">{{ getValidationMessage(registrationForm.controls['email'].errors?.server) | translate }}</div>
                }
              }
            </div>

            <div class="auth-field">
              <hrra-floating-field>
                <input
                  pInputText
                  id="registration-password"
                  class="auth-field__password"
                  [type]="isPasswordVisible ? 'text' : 'password'"
                  autocomplete="new-password"
                  formControlName="password" />
                <label for="registration-password">{{ 'label.Password' | translate }}</label>
                @if (registrationForm.controls['password'].value) {
                  <button type="button" class="auth-field__password-toggle" (click)="isPasswordVisible = !isPasswordVisible">
                    <svg-icon [src]="isPasswordVisible ? '/assets/icons/password-unhide.svg' : '/assets/icons/password-hide.svg'"></svg-icon>
                  </button>
                }
              </hrra-floating-field>
              @if (registrationForm.controls['password'].touched || ngForm.submitted) {
                @if (registrationForm.controls['password'].errors?.pattern && registrationForm.controls['password'].value?.length >= passwordMinLength) {
                  <div class="auth-field__error auth-field__error--with-hint">
                    {{ 'message.PasswordRequirementMessage' | translate }}
                    <span [matTooltip]="'text.PasswordRequirementsText' | translate">
                      <svg-icon
                        src="/assets/icons/info-circle.svg"
                        [svgStyle]="{
                          display: 'flex',
                          'justify-content': 'center',
                          'align-items': 'center'
                        }"></svg-icon>
                    </span>
                  </div>
                }
                @if (registrationForm.controls['password'].errors?.required) {
                  <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
                }
                @if (registrationForm.controls['password'].errors?.minlength) {
                  <div class="auth-field__error">{{ 'message.PasswordTooShort' | translate }}</div>
                }
              }
            </div>

            <div class="registration-form__row">
              <div class="auth-field">
                <hrra-floating-field>
                  <input pInputText id="registration-name" type="text" autocomplete="given-name" formControlName="name" />
                  <label for="registration-name">{{ 'label.Name' | translate }}&nbsp;<span class="auth-field__required">*</span></label>
                </hrra-floating-field>
                @if (registrationForm.controls['name'].touched || ngForm.submitted) {
                  @if (registrationForm.controls['name'].errors?.required) {
                    <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
                  }
                  @if (registrationForm.controls['name'].errors?.pattern) {
                    <div class="auth-field__error">{{ 'message.IncorrectFormat' | translate }}</div>
                  }
                }
              </div>

              <div class="auth-field">
                <hrra-floating-field>
                  <input pInputText id="registration-surname" type="text" autocomplete="family-name" formControlName="surname" />
                  <label for="registration-surname">{{ 'label.Surname' | translate }}&nbsp;<span class="auth-field__required">*</span></label>
                </hrra-floating-field>
                @if (registrationForm.controls['surname'].touched || ngForm.submitted) {
                  @if (registrationForm.controls['surname'].errors?.required) {
                    <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
                  }
                  @if (registrationForm.controls['surname'].errors?.pattern) {
                    <div class="auth-field__error">{{ 'message.IncorrectFormat' | translate }}</div>
                  }
                }
              </div>
            </div>

            <div class="auth-field">
              <!-- <label class="auth-field__label">
                {{ 'label.Phone' | translate }}&nbsp;<span class="auth-field__required">*</span>
              </label> -->
              <!-- the tel input reads country settings only on init, so it waits for the configs -->
              @if (phoneCountrySettings$ | async; as phoneCountrySettings) {
                <ngx-material-intl-tel-input
                  class="auth-tel-input"
                  fieldControlName="phone"
                  [autoIpLookup]="false"
                  [autoSelectedCountry]="phoneCountrySettings.defaultCountry"
                  [preferredCountries]="phoneCountrySettings.preferredCountries"
                  [outputNumberFormat]="phoneOutputFormat"
                  [hidePhoneIcon]="true"
                  [textLabels]="{
                    mainLabel: '',
                    codePlaceholder: '',
                    searchPlaceholderLabel: 'label.Search' | translate,
                    noEntriesFoundLabel: 'label.NoResults' | translate,
                    nationalNumberLabel: 'label.MobilePhone' | translate,
                    hintLabel: '',
                    invalidNumberError: '',
                    requiredError: ''
                  }"
                  (focusout)="registrationForm.controls['phone'].markAsTouched()"></ngx-material-intl-tel-input>
              }
              @if (registrationForm.controls['phone'].touched || ngForm.submitted) {
                @if (registrationForm.controls['phone'].errors?.required) {
                  <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
                }
                @if (registrationForm.controls['phone'].errors?.invalidNumber) {
                  <div class="auth-field__error">{{ 'message.IncorrectFormat' | translate }}</div>
                }
              }
            </div>

            <div class="registration-captcha">
              <re-captcha formControlName="recaptcha" siteKey="{{ recaptchaSiteKey$ | async }}"></re-captcha>
              @if ((registrationForm.controls['recaptcha'].touched || ngForm.submitted) && registrationForm.controls['recaptcha'].errors?.required) {
                <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
              }
            </div>

            <div class="registration-terms">
              <input id="registration-terms" class="auth-checkbox" type="checkbox" formControlName="termsAndConditions" />
              <label class="registration-terms__text" for="registration-terms">
                <span>{{ 'text.TermsAndConditionsAgreementPart1' | translate }}</span>&nbsp;<span
                  class="registration-terms__link"
                  role="button"
                  tabindex="0"
                  (click)="onLegalDocumentLink($event, legalDocumentType.Terms, data.termsAndConditionsContentTitle, data.legalDocumentError)"
                  (keydown)="onLegalDocumentLink($event, legalDocumentType.Terms, data.termsAndConditionsContentTitle, data.legalDocumentError)"
                  >{{ 'text.TermsAndConditionsAgreementLink1' | translate }}</span
                >&nbsp;<span>{{ 'text.TermsAndConditionsAgreementPart2' | translate }}</span>&nbsp;<span
                  class="registration-terms__link"
                  role="button"
                  tabindex="0"
                  (click)="onLegalDocumentLink($event, legalDocumentType.Privacy, data.privacyPolicyTitle, data.legalDocumentError)"
                  (keydown)="onLegalDocumentLink($event, legalDocumentType.Privacy, data.privacyPolicyTitle, data.legalDocumentError)"
                  >{{ 'text.TermsAndConditionsAgreementLink2' | translate }}</span
                >&nbsp;<span>{{ 'text.TermsAndConditionsAgreementPart3' | translate }}</span>
              </label>
            </div>
            @if ((registrationForm.controls['termsAndConditions'].touched || ngForm.submitted) && registrationForm.controls['termsAndConditions'].errors?.required) {
              <div class="auth-field__error registration-terms__error">{{ 'message.YouMustAgreeToProceed' | translate }}</div>
            }

            <button class="registration-submit" type="submit">{{ 'label.Registration' | translate }}</button>

            @if (registrationFailed$ | async) {
              <div class="registration-error">
                <app-jobseeker-error-message
                  [messageHeading]="'message.CommonServerErrorSummary' | translate"
                  [message]="'message.CommonServerErrorDetail' | translate"></app-jobseeker-error-message>
              </div>
            }
          </form>
        </app-spinner>

        @if (!isModalOpened) {
          <div class="auth-switch">
            <span class="auth-switch__text">{{ 'label.AlreadyHaveAnAccount' | translate }}</span>
            <a class="auth-switch__link" [routerLink]="['/jobseeker/sign-in']">{{ 'label.SignIn' | translate }}</a>
          </div>
        }
      </div>
    </div>

    @if (!isModalOpened) {
      <app-jobseeker-recruitment-box class="registration-recruitment"></app-jobseeker-recruitment-box>
    }
  </div>
}
